import React, {useState} from 'react';
import PropTypes from 'prop-types';

export const placeholder_default_value = "placeholder"

const Dropdown = (props) => {

    return (
        <div className={`dropdown ${props.classes ? props.classes : ''}`}>
            {props.minimal? (undefined) : (
                <span className="dropdown__title">{props.title}</span>
            )}
            <select className={`dropdown__select ${props.hasError ? "error" : "normal"} ${props.value===placeholder_default_value ? 'dropdown__choice--placeholder' : undefined}`} onChange={props.onChange} value={props.value}>
                <option className='dropdown__choice--placeholder' value={placeholder_default_value}>{props.placeholder}</option>
                {props.options.map((el) => (
                    <option className='dropdown__choice--item' value={el.id}>{el.name}</option>
                ))}
            </select>
            {props.minimal ? (undefined) : (
                <span className="dropdown__description">{props.description}</span>
            )}
        </div>
    )
}

Dropdown.propTypes = {
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Dropdown;